import AuthorizedRoute from './AuthorizedRoute';

export default AuthorizedRoute;
